<template>
  <div class="account-info-root">
    <el-tabs v-model="activeName">
      <el-tab-pane label="账户信息" name="first">
        <PersonAccount></PersonAccount>
      </el-tab-pane>
      <el-tab-pane label="签署方列表" name="second">
        <signers />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>
<script>
// components
import PersonAccount from "./components/accountInfo/personAccount.vue";
import signers from "./signers.vue"

  export default {
    components: {
      PersonAccount,
      signers
    },
    data () {
      // 这里存放数据
      return {
        activeName: 'first',
      }
    },
    // 方法集合
    methods: {
    },

  }
</script>
<style lang='less' scoped>
  .el-tabs__nav-scroll {
    padding-left: 20px;
  }
  /deep/ .el-tabs__nav-scroll {
    padding-left: 20px;
  }
  // @import url(); 引入公共css类
  .account-info-root{
    height: 77.5vh;
    /*padding: 5px;*/
    overflow: auto;
  }
</style>



// WEBPACK FOOTER //
// pages/tpl/accountInfo.vue